/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { MasterdataService } from '../../../services/masterdata.service';
import {
  AdminCreateOrUpdatePacksRequest,
  AdminGetPacksResponse,
  PackageTags,
  PacksVariation,
  VariantTags,
} from '../../../models/packs/AdminCreateOrUpdatePacksRequest';
import { TherapyPaymentType } from '../../../models/TherapyPlans';
import { PackService } from '../../../services/packs.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { lastValueFrom } from 'rxjs';
import {
  AnyoS3Buckets,
  FileUtilsService,
} from 'projects/app-core/src/service/fileService';
import { GenericMasterData } from '../../../models/masterDataResponse';

@Component({
  selector: 'app-curd-anyo-packs',
  templateUrl: './curd-anyo-packs.component.html',
  styleUrl: './curd-anyo-packs.component.scss',
})
export class CurdAnyoPacksComponent extends AnyoComponent {
  constructor(
    auth: AuthService,
    private toastService: ToastService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private masterdataService: MasterdataService,
    private packService: PackService,
    private utils: UtilsService,
    private fileService: FileUtilsService,
  ) {
    super(auth);
  }

  readonly variantTagOptions = Object.values(VariantTags).map((tag) => ({
    label: tag,
    value: tag,
  }));

  readonly packTagOption = Object.values(PackageTags).map((tag) => ({
    label: tag,
    value: tag,
  }));

  readonly paymentTypeOptions = Object.values(TherapyPaymentType).map(
    (type) => ({
      label: type,
      value: type,
    }),
  );

  packId: string = '';
  isEdit: boolean = false;
  packName: string = '';
  subTitle: string = '';
  internalPackName: string = '';
  packDescription: string = '';
  slugName: string = '';
  isActive: boolean = true;
  isVisible: boolean = true;
  concernOption: { label: string; value: string }[] = [];
  packageTag: string = '';
  image: File | undefined = undefined;
  imageUrl: string | undefined = undefined;
  variations: PacksVariation[] = [
    {
      variantName: '',
      variantTags: [],
      charges: {
        amount: 0,
        markupAmount: 0,
        savingText: '',
        perSessionAmount: 0,
      },
      noOfSessions: {
        primary: 0,
        auxiliary: [0],
      },
      packageDuration: 0,
      paymentType: TherapyPaymentType.RETAIL_PAID,
    },
  ];
  setupScreenCarousal: { title: string; description: string }[] = [];
  title: string = '';
  description: string = '';
  selectedPrimaryConcern: string = '';
  selectedAuxiliaryConcern: string[] = [];
  auxiliaryOptions: { label: string; value: string }[] = [];
  packsExpertise: { label: string; value: string }[] = [];
  currentIndex: number = 0;
  isEditing: boolean = false;
  selectedPrimaryExpertise: string = '';
  assessmentPrompt?: string = '';
  primarySesssionDuration?: number | null = null;
  auxiliarySessionDuration?: number | null = null;
  isTesting: boolean = false;

  async ready() {
    this.loadMasterData();
    if (this.user) {
      const id = this.activatedRoute.snapshot.params['id'];
      this.packId = id;
      if (id) {
        this.isEdit = true;
        await this.getAndSetPack(id);
      }
    }
  }
  concernMasterData: GenericMasterData[] = [];

  async loadMasterData(): Promise<void> {
    this.masterdataService.masterDataList().subscribe({
      next: (masterData) => {
        this.concernMasterData = masterData.therapyConcerns;
        masterData.therapyConcerns.forEach((data) => {
          this.concernOption.push({
            label: data.data,
            value: data.m_id,
          });
        });
        this.auxiliaryOptions = [...this.concernOption];
        masterData.therapyPackExpertise?.forEach((data) => {
          const obj = {
            value: data.m_id!,
            label: data.data,
          };
          this.packsExpertise.push(obj);
        });

        // Print the full array after the mapping is done
        console.log('Full packsExpertise array:', this.packsExpertise);
      },
    });
  }

  getConcernNameById(id: string) {
    if (this.concernMasterData.length < 0) {
      this.loadMasterData();
    }
    const concern = this.concernMasterData.find((data) => data.m_id === id);
    console.log(concern);
    return concern?.data;
  }

  getConcernNames(ids: string[]): string[] {
    return ids
      .map((id) => this.getConcernNameById(id))
      .filter((name): name is string => !!name);
  }

  pack!:AdminGetPacksResponse;
  async getAndSetPack(id: string): Promise<void> {
    this.pageLoading = true;
    this.packService.getPack(id).subscribe({
      next: (pack) => {
        this.pack = pack;
        this.packName = pack.packName;
        this.internalPackName = pack.internalPackName;
        this.packDescription = pack.packDescription;
        this.slugName = pack.slugName;
        this.isActive = pack.active;
        this.isVisible = pack.visible;
        this.packageTag = pack.packTags[0];
        this.imageUrl = pack.packagePicture;
        this.variations = pack.variations;
        this.selectedPrimaryConcern = pack.disciplineDetails[0][0];
        this.selectedAuxiliaryConcern = pack.disciplineDetails[1] || [];
        this.subTitle = pack.subTitle || '';
        this.selectedPrimaryExpertise = pack.primaryTherapistExpertiseId || '';
        this.assessmentPrompt = pack.assessmentPrompt || '';
        this.primarySesssionDuration = pack.primarySesssionDuration || null;
        this.auxiliarySessionDuration = pack.auxiliarySessionDuration || null;
        this.isTesting = pack.isTestPack || false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.pageLoading = false;
      },
      complete: () => {
        this.pageLoading = false;
      },
    });
  }

  filterAuxiliaryOptions() {
    if (this.selectedPrimaryConcern && this.selectedPrimaryConcern.length > 0) {
      this.auxiliaryOptions = this.concernOption.filter(
        (option) => !this.selectedPrimaryConcern.includes(option.value),
      );
      this.selectedAuxiliaryConcern = this.concernOption
        .filter((d) => !this.selectedPrimaryConcern.includes(d.value))
        .map((d) => {
          return d.value;
        });
    } else {
      this.auxiliaryOptions = [];
      this.selectedAuxiliaryConcern = [];
    }
  }
  canAddNewVariant(): boolean {
    const last = this.variations[this.variations.length - 1];
    return (
      last.variantName.trim() !== '' &&
      last.charges.amount > 0 &&
      last.paymentType.trim() !== '' &&
      last.noOfSessions.primary > 0 &&
      last.packageDuration > 0
    );
  }

  addNewVariant(): void {
    this.variations.push({
      variantName: '',
      variantTags: [],
      charges: {
        amount: 0,
        markupAmount: 0,
        savingText: '',
        perSessionAmount: 0,
      },
      noOfSessions: {
        primary: 0,
        auxiliary: [0],
      },
      packageDuration: 0,
      paymentType: TherapyPaymentType.RETAIL_PAID,
    });
  }

  onPackageCardPictureChange($event: any) {
    const file = $event.target.files[0];
    if (file) {
      this.image = file;
    }
  }

  addCarousalText() {
    if (!this.title || !this.description) {
      this.toastService.showError('Please fill all the fields');
      return;
    }
    if (this.isEditing) {
      this.setupScreenCarousal[this.currentIndex] = {
        title: this.title,
        description: this.description,
      };
      this.isEditing = false;
    } else {
      this.setupScreenCarousal.push({
        title: this.title,
        description: this.description,
      });
      this.currentIndex = this.setupScreenCarousal.length - 1;
    }

    this.title = '';
    this.description = '';
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  next() {
    if (this.currentIndex < this.setupScreenCarousal.length - 1) {
      this.currentIndex++;
    }
  }

  editCurrentItem() {
    const item = this.setupScreenCarousal[this.currentIndex];
    this.title = item.title;
    this.description = item.description;
    this.isEditing = true;
  }

  deleteCurrentItem() {
    this.setupScreenCarousal.splice(this.currentIndex, 1);
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  async handleMultipleFileUpload(file: File) {
    let uploadedFileUrl: string = '';

    try {
      const extension = file.name.split('.').pop();
      const filePath = `packs/${this.utils.generateUUID()}/images_.${extension}`;

      const uploadUrl = await lastValueFrom(
        this.fileService.generateUploadUrl(
          AnyoS3Buckets.CDN_BUCKET,
          filePath,
          file.type,
        ),
      );

      this.toastService.showSuccess(`Uploading images`);
      await lastValueFrom(this.fileService.uploadFile(file, uploadUrl.url));
      this.toastService.showSuccess(`Uploading images completed`);
      const fileUrl = `https://cdn.anyo.app/${filePath}`;
      uploadedFileUrl = fileUrl;
      return uploadedFileUrl;
    } catch (e) {
      this.toastService.showError(e + '');
      throw e;
    }
  }

  async savePack() {
    if (
      !this.packName ||
      !this.internalPackName ||
      !this.slugName ||
      !this.packDescription ||
      !this.subTitle
    ) {
      this.toastService.showError('Please fill all the fields');
      return;
    }
    // if (this.variations.length === 0) {
    //   this.toastService.showError('Please add at least one variant');
    //   return;
    // }
    if (this.selectedPrimaryConcern.length === 0) {
      this.toastService.showError('Please select at least one primary concern');
      return;
    }
    if (this.variations.some((variant) => variant.variantName.trim() === '')) {
      this.toastService.showError('Variant name cannot be empty');
      return;
    }
    if (this.variations.some((variant) => variant.paymentType.trim() === '')) {
      this.toastService.showError('Payment type cannot be empty');
      return;
    }
    if (this.variations.some((variant) => variant.packageDuration < 0)) {
      this.toastService.showError('Package duration cannot be 0');
      return;
    }
    if (this.variations.some((variant) => variant.noOfSessions.primary < 0)) {
      this.toastService.showError('No of sessions cannot be 0');
      return;
    }
    if (this.variations.some((variant) => variant.charges.amount < 0)) {
      this.toastService.showError('Amount cannot be 0');
      return;
    }
    if (this.variations.some((variant) => variant.charges.markupAmount < 0)) {
      this.toastService.showError('Markup amount cannot be 0');
      return;
    }
    if (
      this.variations.some((variant) => variant.charges.perSessionAmount < 0)
    ) {
      this.toastService.showError('Per session amount cannot be 0');
      return;
    }
    if (
      this.variations.some(
        (variant) => variant.charges.savingText.trim() === '',
      )
    ) {
      this.toastService.showError('Saving text cannot be empty');
      return;
    }
    // if (this.setupScreenCarousal.length === 0) {
    //   this.toastService.showError('Please add at least one carousal text');
    //   return;
    // }
    const pack: AdminCreateOrUpdatePacksRequest = {
      id: this.packId,
      visible: this.isVisible,
      active: this.isActive,
      packName: this.packName,
      subTitle: this.subTitle,
      packDescription: this.packDescription,
      slugName: this.slugName,
      internalPackName: this.internalPackName,
      packagePicture: '',
      packageCardPicture: '',
      disciplineDetails: [
        [this.selectedPrimaryConcern],
        this.selectedAuxiliaryConcern,
      ],
      // setupScreenCarousal: this.setupScreenCarousal,
      variations: this.variations,
      packTags: this.packageTag
        .split(',')
        .map((tag) => tag.trim() as PackageTags),
      primaryTherapistExpertiseId: this.selectedPrimaryExpertise,
      isTestPack: this.isTesting,
    };
    if (this.assessmentPrompt) {
      pack.assessmentPrompt = this.assessmentPrompt;
    }
    if (this.primarySesssionDuration) {
      pack.primarySesssionDuration = this.primarySesssionDuration;
    }
    if (this.auxiliarySessionDuration) {
      pack.auxiliarySessionDuration = this.auxiliarySessionDuration;
    }
    if (this.image) {
      const fileUrl = await this.handleMultipleFileUpload(this.image);
      pack.packagePicture = fileUrl;
      pack.packageCardPicture = fileUrl;
    } else if (this.isEdit) {
      pack.packagePicture = this.imageUrl!;
      pack.packageCardPicture = this.imageUrl!;
    }

    if (!this.isEdit && !pack.packagePicture) {
      this.toastService.showError('Please upload a package picture');
      return;
    }
    if (!this.isEdit && !pack.packagePicture) {
      this.toastService.showError('Please upload a package picture');
      return;
    }
    this.packService.createOrUpdatePack(pack).subscribe({
      next: () => {
        this.toastService.showSuccess('Pack saved successfully');
        this.router.navigate(['/packs']);
      },
      error: (err) => {
        this.toastService.showAnyoErrorToast(err.error.description);
      },
    });
  }
}
